export default __webpack_public_path__ + "static/MS_Visit-Jackson_1224_JXN-MS-Downtown-Skyline1920px-2900340cf8316e3255d2a381a46e362c.jpg";